import { HOME_SCREEN_PERMISSIONS_INITIAL_STATE } from './chunk-KJO3PPWO.mjs';

// src/helpers/settings/permissions.ts
var getUserRegisterPermissionCore = (permissionKey, state) => {
  const loggedInRoleId = state.loggedInUser.loggedInRole.id;
  const roles = state.settings.selectedMode.currentSettings.roles;
  const rolePermissions = roles[loggedInRoleId];
  return !!rolePermissions.registerPermissions[permissionKey];
};
var getUserEndOfDayPermisionValueCore = (permissionKey, state) => {
  const loggedInRoleId = state.loggedInUser.loggedInRole.id;
  const roles = state.settings.selectedMode.currentSettings.roles;
  const rolePermissions = roles[loggedInRoleId];
  return rolePermissions.endOfDayPermissions[permissionKey];
};
var getUserReportsAvailableCore = (state, roleId) => {
  const roles = state.settings.selectedMode.currentSettings.roles;
  const rolePermissions = roles[roleId];
  return !!rolePermissions && rolePermissions.homeScreenPermissions.reportsModuleAvailable;
};
var getAvailableModulesByRoleCore = (state) => {
  const loggedInRoleId = state.loggedInUser.loggedInRole.id;
  const roles = state.settings.selectedMode.currentSettings.roles;
  const rolePermissions = roles[loggedInRoleId];
  return rolePermissions ? rolePermissions.homeScreenPermissions : HOME_SCREEN_PERMISSIONS_INITIAL_STATE;
};

export { getAvailableModulesByRoleCore, getUserEndOfDayPermisionValueCore, getUserRegisterPermissionCore, getUserReportsAvailableCore };
